import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import moment from 'moment';

// the server sends the subscription's dates as yyyy-MM-dd in the centre's time zone
const formatDay = date => date ? moment(date, 'YYYY-MM-DD').format('ll') : '';

const SubscriptionStatus = ({ subscription, t }) => {
	switch (subscription.status) {
		case 'Active':
			return <span>{t('FO_Subscription_Status_Active', { date: formatDay(subscription.endDate) })}</span>;
		case 'CancellationRequested':
		case 'Cancelled':
			return <span>{t('FO_Subscription_Status_Cancelled', { date: formatDay(subscription.lastDay) })}</span>;
		case 'Ended':
			return <span>{t('FO_Subscription_Status_Ended', { date: formatDay(subscription.endDate) })}</span>;
		default:
			return null;
	}
};

SubscriptionStatus.propTypes = {
	subscription: PropTypes.shape({
		status: PropTypes.string,
		endDate: PropTypes.string,
		lastDay: PropTypes.string
	}).isRequired
};

export { formatDay };

export default withTranslation()(SubscriptionStatus);
